<template>

    <div id="page-company-list" class="vx-card p-6">

        <!-- Searchs-->
        <vx-card ref="filterCard" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
            <div class="vx-row">
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">企業名</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="企業名(入力)" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="companyNameFilter"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">管理者</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="管理者(入力)" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="adminFilter"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">備考</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="備考(入力)" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="remarkFilter"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt">
                    <vs-button icon="search" @click="searchCompanyWithOrder()" class="search_icon mr-6 sm:mr-3">検索</vs-button>
                </div>
            </div>
        </vx-card>

        <!-- Title and Buttons Action -->
        <div class="text-title">
            <span>企業一覧</span>
        </div>
        <vs-row class="pl-2">
            <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
                <span class="pr-2">表示件数:</span>
                <div class="vx-col md:w-24 w-full">
                    <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
                        <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                    </v-select>
                </div>
            </vs-col>
            <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">
                <vs-button color="success" icon="add_circle" @click="setUpCreate">登録</vs-button>
<!--                <vs-button :disabled="ids.length <= 0" color="warning" icon="mail" @click="resetPasswordUser">パスワード設定依頼</vs-button>-->
            </vs-col>
        </vs-row>

        <!--delete popup-->
<!--        <vs-popup id="dialogDelete" title="利用者の削除" :active.sync="activeDelete" button-close-hidden>-->
<!--        <div>-->
<!--          <span>-->
<!--            are you sure delete?-->
<!--          </span>-->
<!--        </div>-->
<!--        <div class="flex justify-end mt-4">-->
<!--            <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>-->
<!--            <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>-->
<!--        </div>-->
<!--    </vs-popup>-->

        <!-- Create and Edit Dialog -->
        <vs-popup id="dialogCompany" :title="title" :active.sync="activePopup" button-close-hidden>
            <div>
                <vx-card title="企業情報登録"
                         card-background ="rgb(240, 238, 241)"
                         height="420px"
                         class="pb-2"
                         style="font-size: 12px">
                    <div>
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span class="pt-2">企業名<span style="color: red">*</span></span>
                            </vs-col>
                            <vs-col vs-w="4">
                                <vs-input :disabled="!addFlg" v-validate.immediate="'required'" maxlength="15" name="漢字" v-model="company.company_name" placeholder="漢字" class="w-full mb-2"/>
                            </vs-col>
                            <vs-col vs-w="1"></vs-col>
                            <vs-col vs-w="4">
                                <vs-input :disabled="!addFlg"  v-validate.immediate="'required'" maxlength="15" name="カナ" v-model="company.company_name_kana" placeholder="カナ" class="w-full mb-2"/>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <!--disable if update-->
                            <vs-col vs-offset="3">
                                <span v-show="submited && addFlg" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("漢字") | convertError }}</span>
                                <span v-show="submited && addFlg" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("カナ") | convertError }}</span>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>登録可能サーバ数<span style="color: red">*</span></span>
                            </vs-col>
                            <vs-col vs-w="3">
                                <vs-row>
                                    <vs-input-number min="1" name="登録可能サーバ数" v-model="company.upper_server_limit" class="w-full mb-2"/>
                                </vs-row>
                            </vs-col>
                            <vs-col vs-w="6"></vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col vs-offset="3">
                                <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("登録可能サーバ数") | convertError }}</span>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>添付ファイル使用容量(GB)</span>
                            </vs-col>
                            <vs-col vs-w="3">
                                <vs-row>
                                    <vs-input-number min="0" v-validate.immediate="'required|numeric'" name="添付ファイル使用容量" v-model="company.attachment_limit" class="w-full mb-2"/>
                                </vs-row>
                            </vs-col>
                            <vs-col vs-w="6"></vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>契約状況</span>
                            </vs-col>
                            <vs-col vs-w="9">
                                <div class="my-2">
                                    <input type="checkbox" v-model="company.state" value class="mr-1" style="position: relative; top: 2px"/>
                                    <span>有効</span>
                                </div>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                          <vs-col class="flex items-center" vs-w="3">
                            <span>チャット機能</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <div class="my-2">
                              <input type="checkbox" v-model="company.enable_chat" value class="mr-1" style="position: relative; top: 2px"/>
                              <span>有効にする</span>
                            </div>
                          </vs-col>
                        </vs-row>
                        <vs-row style="font-size: 12px">
                            <vs-col class="flex items-center" vs-w="3">
                                <span>備考</span>
                            </vs-col>
                            <vs-row vs-w="9">
                                <vs-input name="remark" v-model="company.remark_message" placeholder="備考" class="w-full mb-2"/>
                            </vs-row>
                        </vs-row>
                    </div>
                </vx-card>
                <div style="display: flex; justify-content: flex-end" class="py-4">
                    <vs-button v-if="addFlg" @click="actionCreate" :disabled="!validateForm && submited" icon="add_circle" color="success" style="padding: 8px; margin-right: 5px;height: 37px">登録</vs-button>
                    <vs-button v-else @click="actionUpdate" :disabled="!validateForm" icon="assignment" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
                    <vs-button @click="activePopup = false" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
                </div>
                <div>
                    <admin-company v-if="!addFlg" :companyAdmin="companyAdmin" :company="company" :isShow="activePopup" ref="myChild"></admin-company>
                </div>
            </div>
        </vs-popup>

        <!-- AgGrid Table -->
        <ag-grid-vue
            id="myGrid"
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table database"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="companiesData"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            domLayout="autoHeight"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @selection-changed="onSelectionChanged"
            @sortChanged="onSortChangedEvent"
            :overlayNoRowsTemplate="noRowsTemplate"
            :detailRowAutoHeight="true"
        >
        </ag-grid-vue>

        <div style="position: relative">
            <!-- ITEMS PER PAGE -->
            <div>
                <div class="flex items-center justify-between">
                    <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                </div>
            </div>
            <!-- pagination -->
            <vs-pagination
                    :total="totalPages"
                    v-model="currentPage"
                    :max="0"
                    class="pr-10 pt-10"
            />
        </div>

        <vs-popup class="holamundo"  title="企業設定の削除" :active.sync="popupDelete" button-close-hidden>
            <p>
                選択した企業設定を削除しますか？
            </p>
            <div class="d-flex float-right group-button-delete">
                <vs-button color="#EA5455" class="mr-2" @click="confirmDeleteCompany">削除</vs-button>
                <vs-button color="#B8C2CC" @click="popupDelete = false">キャンセル</vs-button>
            </div>
        </vs-popup>
    </div>


</template>

<script>
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import { AgGridVue } from 'ag-grid-vue'
    import vSelect       from 'vue-select'
    import EventBus      from '../../../EventBus'
    import {mapActions, mapGetters} from 'vuex'
    import AdminCompany from "./AdminCompany";
    // Cell Renderer
    import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'

    export default {
        components: {
            AgGridVue,
            vSelect,
            // Cell Renderer
            CellRendererActions,
            AdminCompany
        },
        data () {
            return {
                popupDelete:false,
                activePopup:     false,
                activeDelete:    false,
                idDelete:    false,
                submited:        false,
                id:              null,
                ids:             [],
                company: null,
                initialCompany: {
                    company_name: '',
                    company_name_kana: '',
                    upper_server_limit: 1,
                    attachment_limit: 0,
                    state: 0,
                    remark_message: ''
                },
                // Filter Options
                companyNameFilter:   null,
                adminFilter:     null,
                remarkFilter:      null,
                paginationOptions: [
                    10, 20, 30, 50
                ],

                //SortServer
                orderBy: 'id',
                orderDir: 'desc',

                //Pagination
                paginationPageSize: 10,
                pageNumber: 1,
                startRow: 0,
                endRow: 0,

                // AgGrid
                noRowsTemplate: "<span>データがありません</span>",
                gridApi: null,
                gridOptions: {
                    onGridSizeChanged: () => {
                        this.gridApi.sizeColumnsToFit();
                    }
                },
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    suppressMenu: true,
                    sortingOrder: ['asc', 'desc'],
                },
                columnDefs: [
                    {
                        headerName: '企業名',
                        field: 'name',
                        filter: true,
                        width: 225,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '契約状態',
                        field: 'state_name',
                        filter: true,
                        width: 50,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'サーバ登録可能数',
                        field: 'upper_server_limit',
                        filter: true,
                        width: 140,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '登録日',
                        field: 'create_at_format',
                        filter: true,
                        width: 140,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '更新日',
                        field: 'update_at_format',
                        filter: true,
                        width: 140,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '備考',
                        field: 'remark_message',
                        filter: true,
                        width: 190,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '',
                        field: 'actions',
                        width: 190,
                        cellRendererFramework: 'CellRendererActions',
                        unSortIcon: false,
                        suppressMovable: true,
                    }
                ],
                // Cell Renderer Components
                components: {
                    CellRendererActions
                },
                addFlg: true,
                companyAdmin: []
            }
        },
        watch: {
            paginationPageSize(val){
                this.setPagination(val);
            }
        },
        computed: {
            ...mapGetters({
                getCompaniesList: 'company/getCompany'
            }),
            validateForm(){
                return !this.errors.any()
            },
            companiesData () {
                let companiesData = []
                this.$store.state.company.companyList.forEach((element) => {
                    let state_name = element.state === 1 ? '有効' : '無効'
                    companiesData.push(Object.assign({
                        name: element.company_name + ' ' + element.company_name_kana,
                        state_name,
                        create_at_format: this.$moment(element.create_at).format('YYYY-MM-DD h:mm:ss'),
                        update_at_format: this.$moment(element.update_at).format('YYYY-MM-DD h:mm:ss'),
                    }, element));
                });
                return companiesData
            },
            totalPages () {
                return parseInt(this.$store.state.company.infoDB.totalPage)
            },
            totalRow(){
                return parseInt(this.$store.state.company.infoDB.totalRow)
            },
            currentPage: {
                get () {
                    return this.pageNumber
                },
                async set (val) {
                    this.pageNumber = val
                    await this.searchCompanyWithOrder();
                    this.ids = []
                    this.gridApi.paginationGoToPage(val-1)
                }
            },
            title() {
                return this.addFlg ? '企業情報登録' : '企業情報更新'
            }
        },
        methods: {
            ...mapActions({
                createCompany: 'company/create',
                updateCompany: 'company/update',
                fetchList: 'company/fetchList',
                fetchCompany: 'company/fetchCompany',
                deleteCompany: 'company/deleteCompany',
            }),
            onSelectionChanged() {
                this.ids = this.gridApi.getSelectedRows().map(user => user.id)
            },
            onSortChangedEvent(event){
                let columns = event.columnApi.getAllColumns();
                let root = this;
                columns.forEach(function(column){
                    if (column.getSort()){
                        root.orderDir = column.getSort()
                        root.orderBy  = column.getColId()
                        root.searchCompanyWithOrder();
                        return;
                    }
                });
            },
            searchCompanyWithOrder(){
                if(this.orderBy == 'name') this.orderBy = 'company_name'
                if(this.orderBy == 'state_name') this.orderBy = 'state'
                if(this.orderBy == 'remark') this.orderBy = 'password'
                this.fetchList({
                    orderBy: this.orderBy,
                    orderDir: this.orderDir,
                    name: this.companyNameFilter,
                    admin: this.adminFilter,
                    remark_message: this.remarkFilter,
                    limit: this.paginationPageSize,
                    page: this.pageNumber
                })
            },
            setUpCreate(){
                // clear all fields before create
                this.company = Object.assign({}, this.initialCompany)
                this.companyAdmin = []
                this.addFlg = true
                this.activePopup = true
            },
            async actionCreate(){
                if(!this.validateForm){
                    this.submited = true; // first: no show error => after submited: show error
                }
                else{
                    let newCompany = Object.assign({}, this.company)
                    await this.createCompany(newCompany)
                    this.activePopup = false
                    await this.searchCompanyWithOrder()
                }
            },
            async actionUpdate(){
                await this.updateCompany(this.company)
                this.activePopup = false
                await this.searchCompanyWithOrder()
            },
            async resetColFilters () {
                // Reset Grid Filter
                this.gridApi.setFilterModel(null)
                this.gridApi.onFilterChanged()
                this.companyNameFilter  = null,
                this.adminFilter     = null,
                this.remarkFilter    = null,
                // this.stateFlgFilter = '...'
                // this.ids = []
                await this.searchCompanyWithOrder()
                this.$refs.filterCard.removeRefreshAnimation()
            },
            async setPagination(val){
                this.gridApi.paginationSetPageSize(val);
                this.pageNumber = 1
                await this.searchCompanyWithOrder();
            },
            editListener(id) {
                this.companyAdmin = [];
                this.addFlg = false
                this.fetchCompany(id)
                    .then(company => {
                        this.company = Object.assign({}, company)
                        this.companyAdmin = company.company_admins
                    })
                this.activePopup = true


            },
            deleteListener(id) {
                this.activeDelete = true
                this.idDelete = id
                this.popupDelete = true
            },
            async confirmDeleteCompany() {
                this.popupDelete = false
                await this.deleteCompany(this.idDelete)
                this.company = this.initialCompany
                await this.searchCompanyWithOrder();
            },
        },
        mounted () {
            this.gridApi = this.gridOptions.api
            if (this.$vs.rtl) {
                const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
                header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
            }
            EventBus.$on('editRecord', this.editListener)
            EventBus.$on('deleteRecord', this.deleteListener);
            // save paginationSize to sessionStorage (when fresh browser)
            const root = this
            window.addEventListener('beforeunload', function(){
                sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
            })
        },
        async created () {
            this.company = this.initialCompany
            await this.searchCompanyWithOrder();
        },
        beforeMount(){
            // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
            let paginationPageSize = sessionStorage.getItem("paginationPageSize");
            if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
        },
        updated(){
            // set paginationPageSize = 10 (default) when change page/route
            sessionStorage.setItem("paginationPageSize", 10)
            // calc number startRow and endRow
            this.$nextTick(()=>{
                if(!this.$store.state.loading && this.companiesData.length > 0){
                    this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
                    if(this.companiesData.length == this.paginationPageSize) this.endRow = this.pageNumber*this.paginationPageSize
                    else this.endRow = this.paginationPageSize*this.pageNumber + this.companiesData.length - this.paginationPageSize
                }
                if(this.companiesData.length == 0){
                    this.endRow = 0
                    this.startRow = 0
                }
            });
        },
        beforeDestroy(){
            EventBus.$off('editRecord', this.editListener);
            EventBus.$off('deleteRecord', this.deleteListener);
        },
        destroyed(){
            // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
            document.getElementById('dialogDelete').style.display = 'none'
            document.getElementById('dialogCompany').style.display = 'none'
        }
    }

</script>

<style lang="scss">
    @import "@/assets/scss/vuexy/components/view/company-setting.scss";
    .group-button-delete {
        display: flex;
    }
</style>
